/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Bidirectional_SyncInputs */

const en_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidirectional sync`)
};

const ar_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزامنة ثنائية الاتجاه`)
};

const bn_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্বিমুখী সিঙ্ক`)
};

const de_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidirektionale Synchronisierung`)
};

const es_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización bidireccional`)
};

const fr_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation bidirectionnelle`)
};

const pt_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização bidirecional`)
};

const zh_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双向同步`)
};

const tr_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çift yönlü senkronizasyon`)
};

const ru_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двунаправленная синхронизация`)
};

const pl_svchip_bidirectional_sync = /** @type {(inputs: Svchip_Bidirectional_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja dwukierunkowa`)
};

/**
* | output |
* | --- |
* | "Bidirectional sync" |
*
* @param {Svchip_Bidirectional_SyncInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_bidirectional_sync = /** @type {((inputs?: Svchip_Bidirectional_SyncInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Bidirectional_SyncInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_bidirectional_sync(inputs)
	if (locale === "bn") return bn_svchip_bidirectional_sync(inputs)
	if (locale === "de") return de_svchip_bidirectional_sync(inputs)
	if (locale === "es") return es_svchip_bidirectional_sync(inputs)
	if (locale === "fr") return fr_svchip_bidirectional_sync(inputs)
	if (locale === "pt") return pt_svchip_bidirectional_sync(inputs)
	if (locale === "zh") return zh_svchip_bidirectional_sync(inputs)
	if (locale === "tr") return tr_svchip_bidirectional_sync(inputs)
	if (locale === "ru") return ru_svchip_bidirectional_sync(inputs)
	if (locale === "pl") return pl_svchip_bidirectional_sync(inputs)
	return en_svchip_bidirectional_sync(inputs)
});